import { widgetTypeIconMap } from '../Widgets/widgetTypeIconMap';

type WidgetTypeIconProps = {
  type: keyof typeof widgetTypeIconMap;
} & Omit<React.SVGProps<SVGElement>, 'type'>;
export const WidgetTypeIcon = ({ type, ...props }: WidgetTypeIconProps) => {
  const Component = widgetTypeIconMap[type];

  return (
    <Component
      {...props}
      style={{
        width: 32,
        height: 32,
        ...props.style,
      }}
    />
  );
};
